import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../../stylesheets/components/header-mobile/quick-buttons.module.css";
import { ActionLinks } from "../../types/index.js";
import { getEnquiryBookingLinks } from "../../utils/utils.js";
import SmartLink from "../SmartLink.js";

interface Props {
  actionLinks: ActionLinks;
  className: string;
  isPreview: boolean;
  isVisible: boolean;
  onClick: () => void;
}

const QuickButtons: FunctionComponent<Props> = ({
  actionLinks,
  className,
  isPreview,
  isVisible,
  onClick,
}) => {
  const links = getEnquiryBookingLinks(actionLinks);

  return !links.length ? null : (
    <div
      className={ClassNames(
        styles.QuickButtons,
        {
          [styles["QuickButtons--preview"]]: isPreview,
          [styles["QuickButtons--hidden"]]: !isVisible,
        },
        className,
      )}
    >
      {links.map(({ label, href, type }) => (
        <div key={type} className={styles.QuickButtons__Item}>
          <SmartLink
            isPreview={isPreview}
            anchorAttrs={{
              className: styles.QuickButtons__Button,
              children: label,
              href,
              onClick,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default QuickButtons;
